import { Box, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

const CopyRight = ({padding}) => {
  return (
    <Box>
         <Typography
            sx={{
              color: "#000",
              fontSize: {md:"14px",xs:"14px"},
              textAlign:"center",
              py:padding?padding:"1.5rem",
              px:padding?padding:"1rem",
              fontFamily:"centuryGothic !important",
              // fontWeight: "600",
              // letterSpacing: "2px",
              "& a":{
                textDecoration:"none",
                color:"inherit"
              }
            }}
          >
           Copyright 2025. Peter M. Litchfield and Sandra Reamer. All rights reserved.  <Link to={"/privacy-policy"}>Privacy Policy</Link> | <Link to={"/terms-and-condition"}>Terms and Conditions</Link>
          </Typography>
    </Box>
  )
}

export default CopyRight